import PaymentIconImage from "@/components/Images/PaymentIconImage";
import { PAYMENT_METHOD_ID } from "@/lib/constants";
import formStyles from "@/styles/Form.module.scss";
import styles from "@/styles/PaymentSelect.module.scss";
import classnames from "classnames";
import { useCallback, useMemo } from "react";
import { IGNORE_CARRIER, IGNORE_PAYPAY, PURCHASE_MODE } from "./index";
import PaymentRadioButton from "./PaymentRadioButton";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export default function PaymentMethodsList(_ref) {
  let {
    mode,
    paymentMethods,
    paymentInstruments,
    register,
    onChange
  } = _ref;
  if (!paymentMethods) return null;
  const purchase = PURCHASE_MODE.includes(mode);
  // 登録済みの支払い方法
  const registeredPaymentMethodIds = useMemo(() => {
    if (!paymentInstruments) return [];
    return paymentInstruments.map(payment => payment.payment_method_id);
  }, [paymentInstruments]);
  // 支払い方法ごとに分ける
  const creditCard = useMemo(() => {
    return paymentMethods.filter(v => v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_3DS);
  }, [paymentMethods]);
  const paypay = useMemo(() => {
    return paymentMethods.filter(v => !IGNORE_PAYPAY.includes(mode) && !registeredPaymentMethodIds.includes(v.payment_method_id) && v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY);
  }, [mode, paymentMethods, registeredPaymentMethodIds]);
  const carrier = useMemo(() => {
    return paymentMethods.filter(v => !IGNORE_CARRIER.includes(mode) && !registeredPaymentMethodIds.includes(v.payment_method_id) && [PAYMENT_METHOD_ID.AU, PAYMENT_METHOD_ID.DOCOMO, PAYMENT_METHOD_ID.SOFTBANK].includes(v.payment_method_id));
  }, [mode, paymentMethods, registeredPaymentMethodIds]);
  const labelClassName = useCallback(v => {
    return classnames(styles.radioCheck, styles.paymentMethodIcon, {
      [styles.creditCard]: v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_3DS || v.payment_method_id === PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS,
      [styles.paypay]: v.payment_method_id === PAYMENT_METHOD_ID.PAYPAY,
      [styles.docomo]: v.payment_method_id === PAYMENT_METHOD_ID.DOCOMO,
      [styles.softbank]: v.payment_method_id === PAYMENT_METHOD_ID.SOFTBANK,
      [styles.au]: v.payment_method_id == PAYMENT_METHOD_ID.AU
    });
  }, []);
  const handleChange = useCallback(e => {
    const paymentMethodId = Number(e.target.value);
    onChange({
      paymentMethod: paymentMethodId,
      createPayment: true,
      showInput: paymentMethodId === PAYMENT_METHOD_ID.CREDIT_CARD_3DS || paymentMethodId === PAYMENT_METHOD_ID.CREDIT_CARD_NO3DS
    });
  }, []);
  return /*#__PURE__*/_jsxs("fieldset", {
    className: `${formStyles.marginOff} ${styles.paymentMethodsListFieldset}`,
    children: [/*#__PURE__*/_jsxs("p", {
      className: styles.paymentInstrumentsListFieldsetTitle,
      children: [purchase && "その他のお支払い方法を利用する", !purchase && "新しく追加するお支払い方法"]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.paymentInstrumentStyle,
      children: [creditCard && /*#__PURE__*/_jsx(_Fragment, {
        children: creditCard.map(v => /*#__PURE__*/_jsx(PaymentRadioButton, {
          ref: register,
          paymentMethodId: v.payment_method_id,
          id: `paymentMethodId${v.payment_method_id}`,
          className: labelClassName(v),
          value: v.payment_method_id,
          onChange: handleChange,
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.iconWithText,
            children: [/*#__PURE__*/_jsx("div", {
              className: styles.cardImage,
              children: /*#__PURE__*/_jsx(PaymentIconImage, {
                large: true,
                paymentMethodId: PAYMENT_METHOD_ID.CREDIT_CARD_3DS,
                cardType: "all"
              })
            }), /*#__PURE__*/_jsx("span", {
              className: styles.paymentCreditCardText,
              children: "\u5404\u7A2E\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9"
            })]
          })
        }, `paymentMethod-${v.payment_method_id}`))
      }), paypay && /*#__PURE__*/_jsx(_Fragment, {
        children: paypay.map(v => /*#__PURE__*/_jsx(PaymentRadioButton, {
          ref: register,
          paymentMethodId: v.payment_method_id,
          id: `paymentMethodId${v.payment_method_id}`,
          className: labelClassName(v),
          value: v.payment_method_id,
          onChange: handleChange,
          children: /*#__PURE__*/_jsx(PaymentIconImage, {
            large: true,
            paymentMethodId: v.payment_method_id
          })
        }, `paymentMethod-${v.payment_method_id}`))
      }), carrier && /*#__PURE__*/_jsx("div", {
        className: styles.carrierPayments,
        children: carrier.map(v => /*#__PURE__*/_jsx(PaymentRadioButton, {
          ref: register,
          paymentMethodId: v.payment_method_id,
          id: `paymentMethodId${v.payment_method_id}`,
          className: labelClassName(v),
          value: v.payment_method_id,
          onChange: handleChange,
          children: /*#__PURE__*/_jsx(PaymentIconImage, {
            large: true,
            paymentMethodId: v.payment_method_id
          })
        }, `paymentMethod-${v.payment_method_id}`))
      }), !IGNORE_CARRIER.includes(mode) && purchase && /*#__PURE__*/_jsx("p", {
        className: styles.caution,
        children: "\u30AD\u30E3\u30EA\u30A2\u6C7A\u6E08\u3092\u65B0\u898F\u3067\u3054\u767B\u9332\u3044\u305F\u3060\u304F\u969B\u3001\u5404\u30AD\u30E3\u30EA\u30A2\u306E\u30DA\u30FC\u30B8\u3067\u304A\u624B\u7D9A\u304D\u5F8C\u306B\u5546\u54C1\u8CFC\u5165\u78BA\u8A8D\u753B\u9762\u306B\u623B\u3063\u3066\u304F\u308B\u5834\u5408\u304C\u3054\u3056\u3044\u307E\u3059\u306E\u3067\u3001\u624B\u7D9A\u3092\u4E2D\u65AD\u3055\u308C\u306C\u3088\u3046\u304A\u6C17\u3092\u3064\u3051\u304F\u3060\u3055\u3044\u3002"
      }), IGNORE_CARRIER.includes(mode) && /*#__PURE__*/_jsx("div", {
        className: formStyles.caption,
        children: "\u65B0\u898F\u3067\u306E\u5546\u54C1\u8CFC\u5165\u6642\u306E\u3010\u30AD\u30E3\u30EA\u30A2\u6C7A\u6E08\u3011\u306E\u5BFE\u5FDC\u3092\u7D42\u4E86\u3044\u305F\u3057\u307E\u3057\u305F\u306E\u3067\u3001\u304A\u652F\u6255\u65B9\u6CD5\u3068\u3057\u3066\u8FFD\u52A0\u306F\u3067\u304D\u307E\u305B\u3093"
      })]
    })]
  });
}